export type ImageBackground = 'white' | 'transparent';

const SAMPLE_SIZE = 64;
const OPAQUE_ALPHA = 128;
const MIN_TRANSPARENT_SHARE = 0.02;
const DARK_LUMINANCE = 128;

// Returns null for an opaque image, where the background choice changes nothing.
export const detectImageBackground = (img: HTMLImageElement): ImageBackground | null => {
  const canvas = document.createElement('canvas');
  canvas.width = SAMPLE_SIZE;
  canvas.height = SAMPLE_SIZE;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  if (!ctx) return null;

  ctx.drawImage(img, 0, 0, SAMPLE_SIZE, SAMPLE_SIZE);
  const { data } = ctx.getImageData(0, 0, SAMPLE_SIZE, SAMPLE_SIZE);

  let transparentCount = 0;
  let opaqueCount = 0;
  let luminanceSum = 0;

  for (let i = 0; i < data.length; i += 4) {
    if (data[i + 3] < OPAQUE_ALPHA) {
      transparentCount += 1;
      continue;
    }
    opaqueCount += 1;
    luminanceSum += 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];
  }

  const pixelCount = data.length / 4;
  if (transparentCount / pixelCount < MIN_TRANSPARENT_SHARE) return null;
  if (opaqueCount === 0) return 'transparent';

  return luminanceSum / opaqueCount < DARK_LUMINANCE ? 'white' : 'transparent';
};
